import { Challenges } from '@app-velocity/modules/scenarios';

import { CreateAChallengeCard } from '../../../../components/CreateAChallengeCard';
import { useWorkspaceContext } from '../../context/useWorkspaceContext';

export const ChallengesSection = () => {
  const { anyChallenges, anyChallengesOrAppraisals, fileId } =
    useWorkspaceContext();

  if (!anyChallenges)
    return (
      <CreateAChallengeCard
        mode="authorized"
        withLinks={anyChallengesOrAppraisals}
      />
    );

  return <Challenges fileId={fileId} />;
};
